import classNames from "classnames";
import { uniqueId } from "lodash";
import Select from "PFComponents/select/select";
import PropTypes from "prop-types";
import React, { useMemo } from "react";

import css from "./inline_select.module.scss";

const InlineSelect = ({
  id,
  disabled,
  label,
  value,
  options,
  onChange,
  selectedIndex,
  rootClassName,
  style,
  inputInnerStyle,
  dropdownStyle,
  classes,
  kind
}) => {
  const uniqId = useMemo(() => id || uniqueId(label || ""), []);
  return (
    <div className={classNames(css.root, rootClassName)} style={style}>
      {label && (
        <label htmlFor={uniqId} className={css.label}>
          {label}
        </label>
      )}
      <Select
        id={uniqId}
        handleChange={onChange}
        displayValue={value}
        options={options}
        selectedIndex={selectedIndex}
        controlledValue
        inputInnerStyle={inputInnerStyle}
        kind={kind || "bordered"}
        noPadding
        rootClassName={classes.selectRoot}
        dropdownStyle={dropdownStyle}
        disabled={disabled}
      />
    </div>
  );
};

InlineSelect.propTypes = {
  id: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.node,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      item: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      displayElement: PropTypes.node
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  selectedIndex: PropTypes.number,
  rootClassName: PropTypes.string,
  style: PropTypes.object,
  inputInnerStyle: PropTypes.object,
  dropdownStyle: PropTypes.object,
  classes: PropTypes.shape({
    selectRoot: PropTypes.string
  }),
  kind: PropTypes.oneOf(["bordered", "blank"])
};

InlineSelect.defaultProps = {
  classes: {}
};

export default InlineSelect;
